// ── Filter field enums (send exactly these strings to the API) ────────────────

export enum SelectColumnsForFiltersForDTO {
  VIRUS_NAME = "virusName",
  SOURCE_IDS = "sourceIds",
}

export enum ExactMatchColumnsForFiltersForDTO {
  BSADB_ID = "bsadbId",
  CHEMBL_ID = "chemblId",
  PUBCHEM_ID = "pubchemId",
  BINDINGDB_ID = "bindingdbId",
  SMILES = "smiles",
}

export enum RangeColumnsForFiltersForDTO {
  CALCULATED_MW = "calculatedMW",
  CALCULATED_LOG_P = "calculatedLogP",
  CALCULATED_TPSA = "calculatedTPSA",
  QED = "qed",
  SA_SCORE = "saScore",
  CLUSTER_ID = "clusterId",
  HADES_SCORE = "hadesScore",
}

// ── Filter item shapes ──────────────────────────────────────────────────────────

export interface ISelectFilterItem {
  field: SelectColumnsForFiltersForDTO;
  value: string[];
}

export interface IExactMatchFilterItem {
  field: ExactMatchColumnsForFiltersForDTO;
  value: string | number;
}

export interface IRangeFilterItem {
  field: RangeColumnsForFiltersForDTO;
  min?: number;
  max?: number;
}

/** The three filter arrays, as sent in the request body — every key optional. */
export interface IDataFilters {
  selectFilters?: ISelectFilterItem[];
  exactMatchFilters?: IExactMatchFilterItem[];
  rangeFilters?: IRangeFilterItem[];
}

export interface IGetMolecularDataRequest {
  filters?: IDataFilters;
  page?: number;
  pageSize?: number;
}

// ── Row / cell shapes ────────────────────────────────────────────────────────

export interface ILinkValue {
  id: string;
  link: string;
}

export type ICellValue =
  string | number | boolean | null | ILinkValue | (string | number)[];

export type IDataRow = Record<string, ICellValue>;

export interface IMetadata {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}

/** Absolute min/max of a range field over the whole unfiltered dataset. */
export interface IRangeBound {
  field: RangeColumnsForFiltersForDTO;
  min: number;
  max: number;
}

export interface IGetMolecularDataResponse {
  data: IDataRow[];
  selectFilter: ISelectFilterItem[] | null;
  exactMatchFilter: IExactMatchFilterItem[] | null;
  rangeFilter: IRangeFilterItem[] | null;
  metadata: IMetadata;
  columns: Array<{ key: string; name: string }>;
  viruses: string[] | null;
  rangeBounds: IRangeBound[];
}
